import { all } from 'redux-saga/effects';
import SyncOfflineProtocol from './SyncOfflineProtocol';
import SyncOfflineProtocolPreview from './SyncOfflineProtocolPreview';
import offlineProtocolPostSignature from './postSignature';
import checkOfflinePdf from './checkOfflinePdf';
import postOfflineProtocolCheckoutStatus from './postOfflineProtocolCheckoutStatus';
import getOfflineProtocolCheckoutId from './getOfflineProtocolCheckoutId';
import checkOfflineProtocolFinishReadiness from './checkOfflineProtocolFinishReadiness';
import offlineMediaPatch from './offlineMediaPatch';

export default all([
    getOfflineProtocolCheckoutId,
    SyncOfflineProtocol,
    SyncOfflineProtocolPreview,
    offlineProtocolPostSignature,
    checkOfflinePdf,
    postOfflineProtocolCheckoutStatus,
    checkOfflineProtocolFinishReadiness,
    offlineMediaPatch
]);
